export const ExportarExcelIcon = () => (
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.75 0.375H9.12891L13.25 4.49609V16.625H0.75V0.375ZM2 1.625V15.375H12V5.375H8.25V1.625H2ZM9.5 2.50391V4.125H11.1211L9.5 2.50391ZM6.375 6.625H7.625V9.75H9.5L7 12.25L4.5 9.75H6.375V6.625ZM4.5 12.875H9.5V14.125H4.5V12.875Z"
      fill="black"
    />
  </svg>
);
